import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { INDUSTRIES } from '@/lib/content';
import SEO from '@/components/SEO';

export default function Industries() {
    return (
        <div className="pt-32 bg-white">
            <SEO title="Industries" description="From automotive to enterprise, consumer products and emerging technology — the verticals CFL Ad Group knows cold." path="/industries" />
            <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-16">
                <div className="text-xs uppercase tracking-[0.35em] font-bold text-brand-orange mb-5">
                    Our Industries
                </div>
                <h1 className="font-display font-black text-brand-navy text-5xl md:text-7xl lg:text-8xl tracking-tight leading-[0.95] max-w-5xl">
                    The verticals<br />
                    <span className="italic font-medium text-brand-orange">we know cold.</span>
                </h1>
                <p className="text-brand-navy/70 text-lg max-w-2xl mt-8 leading-relaxed">
                    From multi-rooftop automotive groups to ambitious enterprise brands —
                    each industry gets a custom-built playbook, not a recycled deck.
                </p>
            </section>

            <section className="bg-brand-cream">
                <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 md:py-18 lg:py-20">
                    <div className="grid lg:grid-cols-2 gap-6">
                        {INDUSTRIES.map((ind, idx) => (
                            <article
                                key={ind.key}
                                className="relative overflow-hidden bg-brand-navy text-white group min-h-[420px]"
                            >
                                <img
                                    src={ind.image}
                                    alt={ind.title}
                                    className="absolute inset-0 w-full h-full object-cover opacity-55 group-hover:opacity-70 group-hover:scale-105 transition-all duration-700"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy via-brand-navy/85 to-brand-navy/20" />
                                <div className="relative p-7 md:p-9 lg:p-10 h-full flex flex-col justify-end">
                                    <div className="flex items-start justify-between gap-6 mb-5">
                                        <span className="font-mono text-xs uppercase tracking-[0.3em] text-brand-orange font-bold">
                                            {String(idx + 1).padStart(2, '0')} / 04
                                        </span>
                                        <ArrowUpRight className="w-5 h-5 text-white/60 group-hover:text-brand-orange transition-colors" />
                                    </div>
                                    <h3 className="font-display font-extrabold text-3xl md:text-4xl text-white tracking-tight mb-4 leading-tight">
                                        {ind.title}
                                    </h3>
                                    <p className="text-white/85 leading-relaxed mb-6">{ind.body}</p>
                                    <Link
                                        to="/contact"
                                        className="inline-flex items-center gap-2 text-brand-orange hover:text-white text-xs uppercase tracking-[0.25em] font-bold w-fit"
                                    >
                                        Discuss your category <ArrowUpRight className="w-4 h-4" />
                                    </Link>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
